<template>
  <div class="bm-player-info" v-cloak >
    <div class="header" >
      <div class="title">{{match.name}}</div>
      <div class="team-box">
        <div class='left'>
          <div class='name'>
            <div>
              <img class="logo" v-if="team.badge" :src="teamLogo" >
              <img class="logo" v-else src="@/assets/images/team-logo-empty.png" />
            </div>
            <div class="team-name">{{team.name}}</div>
          </div>
        </div>
      </div>
      <div class='infotext'>查询到在{{association.name}}的球员注册信息</div>
    </div>
    <div class="sign-form" v-if="clientPlayer.signupAlready == 1">
      <van-cell-group>
        <van-cell title="审核状态" :value="clientPlayer.auditDesc" />
        <van-cell title="注册编号" :value="clientPlayer.serialNumber" />
        <van-cell title="姓名" :value="clientPlayer.trueName" />
        <van-cell title="球衣号码" :value="clientPlayer.number" />
      </van-cell-group>
      <div class='next-btn'>
        <van-button  @click="goDetailPage" type="primary" block>查看我的完整报名信息</van-button>
      </div>
    </div>
    <div class="sign-form" v-else>
      <van-cell-group>
        <van-cell title="注册编号" :value="clientPlayer.serialNumber" />
        <van-cell title="姓名" :value="clientPlayer.trueName" />
        <van-cell title="身份证号" :value="clientPlayer.certNum" />
        <van-cell title="出生日期" :value="clientPlayer.birthday" />
      </van-cell-group>
      <div class='next-btn'>
        <van-button  @click="goNextPage" type="primary" block>使用以上信息报名</van-button>
        <br>
        <van-button  @click="goOtherPage" type="default" block>使用其他身份报名</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { getAssociationMatchPlayerSignupInfoByCertInfo, getAssociationMatchPlayerSignupInfo } from '@/api/team'
import { ImageFormat } from '@/utils/'
import { getUserInfo } from '@/libs/cookie-storage'
import {Cell, CellGroup, Button, SwipeCell, Toast} from 'vant'

Vue.use(Cell).use(CellGroup).use(Button).use(SwipeCell)

const defaultMatch = {name: '', id: ''}
const defaultAssociation = {name: '', id: ''}
const defaultTeam = {name: '', id: '', badge: ''}
const defaultPlayer = {
  trueName: '',
  id: '',
  isTeamLeader: '',
  auditProgress: 0,
  auditDesc: '',
  signupAlready: '0',
  serialNumber: '',
  number: '',
  certNo: '',
  birthday: ''
}

const auditState = ['待审核', '审核通过', '审核拒绝']

export default {
  name: 'PlayerInfo',
  data() {
    return {
      matchId: '',
      teamId: '',
      match: defaultMatch,
      association: defaultAssociation,
      team: defaultTeam,
      player: defaultPlayer,
      clientPlayer: defaultPlayer
    }
  },
  computed: {
    teamLogo() {
      return ImageFormat.imageView(this.team.badge, 104, 104)
    }
  },
  created() {
  },
  mounted() {
    this.teamId = this.$route.query.teamId
    this.matchId = this.$route.query.matchId
    this.getAssociationMatchPlayerSignupInfo()
    this.getAssociationMatchPlayerSignupInfoByCertInfo()
  },
  methods: {
    goDetailPage() {
      this.$router.push({
        path: '/invite-player',
        query: {
          teamId: this.teamId,
          matchId: this.matchId,
          playerId: this.clientPlayer.id
        }
      })
    },
    goNextPage() {
      this.$router.push({
        path: '/participate/player-edit',
        query: {
          teamId: this.teamId,
          matchId: this.matchId,
          playerId: this.clientPlayer.id,
          number: this.clientPlayer.number,
          mobile: this.clientPlayer.mobile,
          insureFile: this.clientPlayer.insureFile,
          forSelf: this.$route.query.forSelf
        }
      })
    },
    goOtherPage() {
      if (this.player.isTeamLeader === '1') { // 当前用户是否为队长
        this.$router.push({
          path: '/invite-team-edit/info',
          query: {
            teamId: this.teamId,
            matchId: this.matchId
          }
        })
      } else {
        this.$router.push({
          path: '/invite-player',
          query: {
            teamId: this.teamId,
            matchId: this.matchId
          }
        })
      }
    },
    getAssociationMatchPlayerSignupInfoByCertInfo() {
      const name = this.$route.query.name
      const certNum = this.$route.query.certNum
      if (!name || !certNum) {
        Toast('用户信息不能为空')
        return
      }
      const params = {
        matchId: this.matchId,
        teamId: this.teamId,
        name: name,
        certNum: certNum
      }
      getAssociationMatchPlayerSignupInfoByCertInfo(params).then((response) => {
        const data = response.data
        this.match = data.match
        this.association = data.association
        this.team = data.team
        if (data.player) { // 一定能查到：已在协会尚未报名，报名提交中
          this.clientPlayer = data.player
          this.clientPlayer.auditDesc = auditState[data.player.auditProgress]
        }
      })
    },
    getAssociationMatchPlayerSignupInfo() {
      const userInfo = getUserInfo()
      const params = {
        matchId: this.matchId,
        teamId: this.teamId
      }
      if (userInfo.id) {
        params.userId = userInfo.id
      }
      getAssociationMatchPlayerSignupInfo(params).then((response) => {
        if (response) {
          this.player = response.data.player || {}
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .bm-player-info{
    padding: 15px;
    .header{
      .title{
        padding-top: 20px;
        font-size: 16px;
        text-align: center;
      }
      .team-box{
        font-size: 14px;
        position: relative;
        margin-top: 15px;
        .left{
          float: left;
          .logo {
            width: 52px;
            height: 52px;
            border-radius: 4px;
          }
        }
        .right{
          float: right;
          padding-top: 25px;
        }
        .name{
          padding-top: 20px;
          font-size: 14px;
          text-align: left;
        }
        .team-name {
          position: absolute;
          top: 36px;
          left: 60px;
          width: 220px;
        }
      }
      .infotext{
        text-align: left;
        margin-top: 20px;
        font-size: 12px;
        padding: 15px 0;
        clear: both;
        padding-left: 15px;
      }
    }
    .sign-form{
      .infotext{
        font-size: 10px;
        text-align: center;
        margin: 10px;
      }
      .radio{

      }
      .next-btn{
        padding: 10px;
        margin-top: 10px;
        text-align: center;
        .next{

        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/team/participate/player-info.vue